export default {
      id: "icon--wear-tshorts-usage",
      viewBox: "0 0 21.1 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wear-tshorts-usage",
      toString: function () {
        return this.url;
      }
    }